module.exports = __webpack_public_path__ + "static/man-f765b135acf3d3cd6f2c54e88e36867f.png";